const getSupplierAddress = ({ business, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (business['Company Address'] && business['Company Address'].ID) {
    if (business['Company Address'].Suite) {
      return `${business['Company Address'].Street} ST. SUITE ${business['Company Address'].Suite}`.toUpperCase();
    }
    return `${business['Company Address'].Street} ST.`.toUpperCase();
  }
  return null;
};

export default getSupplierAddress;



// WEBPACK FOOTER //
// ./src/utils/print/getSupplierAddress.js